<template>
  <el-dialog title="Email Detail" :close-on-click-modal="false" :visible.sync="visible" width="1200px" top="3vh">
    <div class="pb20">
      <div class="emailWrap" v-loading="loading">
        <h3 class="mt0 mb0 pb10 fs20 bottomLine">{{ detailInfo.emailSubject }}</h3>
        <div class="snapshot">
          <div v-html="detailInfo.emailContent || ''"></div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      detailInfo: {},
      loading: false,
    };
  },
  methods: {
    async init(data) {
      this.visible = true;
      await this.$nextTick();
      this.getDetailInfo(data);
    },
    // 获取列表
    getDetailInfo(data) {
      this.loading = true;
      this.$http
        .get("/admin/promoEmailPushDetail/detail", {
          params: {
            id: data.id,
          },
        })
        .then(res => {
          const resData = res.data || {};
          this.detailInfo = resData;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.emailWrap {
  max-height: 80vh;
  overflow-y: auto;

  .bottomLine {
    border-bottom: 1px solid #dcdfe6;
  }

  // 回显内容经 v-html 渲染, 不带 scoped 属性, 需深度选择器穿透;
  // 全局 _normalize.scss 清掉了 ul/ol 的 list-style, 此处恢复列表符号
  .snapshot {
    ::v-deep {
      ol {
        list-style: decimal;
        padding-left: 20px;
      }
      ul {
        list-style: disc;
        padding-left: 20px;
      }
    }
  }
}
</style>
